import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { frontendURL } from 'dashboard/helper/URLHelper';
import SettingsShellWrapper from '../settings/SettingsShellWrapper.vue';
import Automation from '../settings/automation/Index.vue';

/**
 * Workflows as a top-level product area (DECISIONS.md D12).
 *
 * This is the automation-rules screen, not the premium `conversationWorkflow`
 * feature that shares the word - see D7.
 *
 * The existing `automation_list` route under Settings stays registered and
 * reachable, so no bookmark or deep link breaks; this route is an additional
 * way in, exactly as the Overview route was. Both mount the same component and
 * the same `automations` store module - nothing is forked (D4).
 *
 * `SettingsShellWrapper` is reused as the page container because that is all it
 * is: a full-pane `router-view` for pages that own their own header bar. It
 * holds no settings-specific state.
 */
export const routes = [
  {
    path: frontendURL('accounts/:accountId/workflows'),
    component: SettingsShellWrapper,
    children: [
      {
        path: '',
        name: 'workflows_index',
        component: Automation,
        meta: {
          featureFlag: FEATURE_FLAGS.AUTOMATIONS,
          permissions: ['administrator'],
        },
      },
    ],
  },
];
